import { useMemo } from 'react'
import { useApp } from '@wap-client/core'
import { Language } from '@wap-client/services'

export interface IUseIsDirectionRtl {
  isRtl: boolean
  rtlLanguages: Language[]
}

const useDirectionRtl = (): IUseIsDirectionRtl => {
  const { language, languages = [] } = useApp()

  const rtlLanguages = useMemo(
    () => languages.filter((lng): lng is Language => lng?.isRightDirection),
    [languages],
  )

  const isRtl = useMemo(() => {
    if (language) {
      const curr = !!rtlLanguages.find((lng) => lng?.code === language)
      return curr
    }
    return rtlLanguages.length > 0
  }, [language, rtlLanguages])

  return { isRtl, rtlLanguages }
}

export default useDirectionRtl
